import { PPCLoginFlow } from '@contracts';

/**
 * Gets the period pain consultation login flow configuration.
 *
 * @returns {PPCLoginFlow} When in the flow login is required:
 * - AFTER_QUESTIONNAIRE: Login after completing the questionnaire
 * - BEFORE_INTRO: Login before seeing the introduction
 * - AFTER_INTRO: Login after seeing the introduction
 */
export const getPPCLoginFlow = (): PPCLoginFlow => {
  return (process.env.PPC_LOGIN_FLOW as PPCLoginFlow) || PPCLoginFlow.AFTER_QUESTIONNAIRE;
};

/**
 * Determines if the user should continue the PPC questionnaire based on the login flow and authentication state.
 *
 * @param {object} params - Parameters for determining navigation
 * @param {PPCLoginFlow} params.loginFlow - The current PPC login flow setting
 * @param {boolean} params.loggedIn - Whether the user is logged in
 * @returns {boolean} Whether the user should continue the questionnaire
 */
export const shouldContinueQuestionnaire = ({ loginFlow, loggedIn }: { loginFlow: PPCLoginFlow; loggedIn: boolean }): boolean => {
  return (
    loginFlow === PPCLoginFlow.AFTER_QUESTIONNAIRE ||
    (loggedIn && (loginFlow === PPCLoginFlow.BEFORE_INTRO || loginFlow === PPCLoginFlow.AFTER_INTRO))
  );
};
